import React from 'react';
import { Tutorial } from '@lumapps/tutorials/components/Tutorial';

export const FrontOfficeTutorial = () => <Tutorial  />;
